import { money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetVaroLineOfCreditDetails = gql`
  fragment IconStyleDictionaryFragment on IconStyleDictionary {
    id
    iconKey
    fallbackURL
  }

  fragment analyticsEventFragment on AnalyticsEvent {
    name
    properties {
      key
      value
    }
  }

  fragment TransactionRowComponentFragment on TransactionRowComponent {
    ... on TransactionRowComponent {
          primaryDetail {
            copy
          }
          primaryText {
            copy
          }
          secondaryDetail {
            copy
          }
          secondaryText {
            copy
          }
          id
        }
    id
    onClick {
        ... on ISDAction {
            id
            analyticsEvent {
                ... analyticsEventFragment
            }
        }
        ... on TransactionDetailsNavigationAction {
            id
            analyticsEvent {
                ... analyticsEventFragment
            }
            transaction {
                id
                type
                detailsR2 {
                    title
                    items {
                        title
                        value
                    }
                }
                ... on RdcTransaction {
                    rdcId
                }
            }
        }
    }
  }

  fragment bannerFragment on LineOfCreditDetailBanner {
    message
    title
    bannerStatus
  }

  query GetLineOfCreditDetailsResult {
    getLineOfCreditDetailsResult {
      banner{
        ...bannerFragment
      }
      amountDue {
        ...money
      }
      dueDate
      isAutopayEnabled
      paymentSchedule
      remainingBalance {
        ...money
      }
      transactions {
        children {
          ...TransactionRowComponentFragment
        }
        icon {
          ...IconStyleDictionaryFragment
        }
        id
        title {
          copy
        }
      }
      installmentsData {
        remainingBalance {
          ...money
        }
        paidToDate {
          ...money
        }
        installments {
          amountDue {
            ...money
          }
          dueDateFormatted
          installmentState
        }
      }
    }
    ${money}
  }
`;

export default GetVaroLineOfCreditDetails;
